import { useEffect, useState } from "react";
import { httpGet } from "../helpers/httpMethods";

// Is Pay bills switched on for this signed-in reader? One request per sign-in, shared by every touchpoint
// (home strip, header menu, account, the line after a paper is paid for). Signed-out readers never see bills.
let cache = { token: null, promise: null };
export function billsOn() {
  let token = "";
  try { token = localStorage.getItem("token") || ""; } catch (e) { token = ""; }
  if (!token) return Promise.resolve(false);
  if (cache.token !== token || !cache.promise) {
    cache = { token, promise: httpGet("bills/catalogue").then((r) => Boolean(r && r.data && r.data.enabled)).catch(() => false) };
  }
  return cache.promise;
}

export function useBillsOn() {
  const [on, setOn] = useState(false);
  useEffect(() => {
    let alive = true;
    billsOn().then((v) => alive && setOn(v));
    return () => { alive = false; };
  }, []);
  return on;
}
